
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/marketing",
      function () {
        return require("private-next-pages/use-cases/marketing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-cases/marketing"])
      });
    }
  